export default __webpack_public_path__ + "static/column-img-1-d4831f9a8660d23c43ea8b281dc92810.jpg";